import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric, Typography } from '@blade/ui-kit'
import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { NetworkIcon } from '@root/entities/network/ui'
import { Trend } from '@root/entities/trend'
import { trendUpDownDataColorCss } from '@root/entities/trend/ui/trend-ui-utils'

import { positionTableCurrencyTypeAtom } from '../atoms'

import type {
  AggregatedPositionModel,
  WalletPositionModel,
} from '@root/entities/position'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  position: WalletPositionModel | AggregatedPositionModel
} & ClassNameProps

export const PositionsTablePnlCell: React.FC<Props> = ({
  className,
  position,
}) => {
  const [pnlUsd] = useAtom(position.pnlUsd)
  const [pnlNative] = useAtom(position.pnlNative)

  const [currencyType] = useAtom(positionTableCurrencyTypeAtom)
  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)
  const pnlValue =
    currencyType === 'native' ? pnlNative.pnlNative : pnlUsd.pnlUsd
  const pnlPercent =
    currencyType === 'native' ? pnlNative.pnlPercentage : pnlUsd.pnlPercentage

  const valueTrend = Trend.of(pnlValue)

  return (
    <Root className={className}>
      <Amount variant="body4-medium" data-trend={valueTrend}>
        <Numeric
          value={pnlValue}
          preset="currency-amount-short"
          forceSign
          currency={currencyType === 'native' ? undefined : '$'}
        />
        {currencyType === 'native' && (
          <NetworkIcon size={13} network={nativeCurrency.network} />
        )}
      </Amount>
      <AmountCurrency variant="description-medium">
        <Numeric value={pnlPercent} preset="percents" forceSign />%
      </AmountCurrency>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 1px;
`

const Amount = styled(Typography)`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 2px;

  ${trendUpDownDataColorCss}
`

const AmountCurrency = styled(Typography)`
  color: var(--text-11);
  ${trendUpDownDataColorCss}
`
